import {createContext, useContext} from 'react';
import {Outlet} from 'react-router-dom';

const AppWrapperContext = createContext({Sidebar: null});

export const useAppWrapper = () => useContext(AppWrapperContext);

const AppWrapper = ({children}) => {
  const {Sidebar} = useAppWrapper();

  return (
    <div className="flex" style={{height: 'calc(100vh - 64px)'}}>
      {Sidebar && <div className="w-64" style={{position: 'fixed', zIndex: '1000'}}>{Sidebar}</div>}
      <div
        className="main-body flex-1 p-6"
        style={{
          overflowX: 'scroll',
          marginLeft: '65px',
          background: 'linear-gradient(to top, #d5eaf9, #ffffff)',
      }}
      >
        {children}
      </div>
    </div>
  );
};

// Compound component wrapper
AppWrapper.WithSidebar = ({children, sidebar}) => (
  <AppWrapperContext.Provider value={{Sidebar: sidebar}}>
    <AppWrapper>
      {children}
    </AppWrapper>
  </AppWrapperContext.Provider>
);

export default AppWrapper;
